<template>
  <v-container>
    <v-card class="pa-6 mx-auto" max-width="560">
      <h1 class="text-h5 mb-4">Confirm your new email</h1>
      <p v-if="!confirmed">Confirming signs out existing sessions and renews your API key. You can then sign in with the new address.</p>
      <v-alert v-if="error" type="error">{{ error }}</v-alert>
      <v-alert v-if="confirmed" type="success">Email confirmed. Sign in with your new address.</v-alert>
      <v-btn v-if="!confirmed" color="primary" :disabled="!token || busy" :loading="busy" @click="confirm">Confirm email change</v-btn>
      <v-btn v-else color="primary" to="/login">Sign in</v-btn>
    </v-card>
  </v-container>
</template>
<script>
import { apiClient } from "@shared/services/api";
export default {
  name: "ConfirmEmailChangeView",
  data() { return { token: "", busy: false, error: "", confirmed: false }; },
  created() {
    this.token = new URLSearchParams((this.$route.hash || window.location.hash).substring(1)).get("email_change") || "";
    window.history.replaceState(window.history.state, "", window.location.pathname + window.location.search);
    if (!this.token) this.error = "Open the confirmation link from your email.";
  },
  methods: {
    async confirm() {
      this.busy = true;
      this.error = "";
      try {
        await apiClient.post("/auth/email-change/confirm", { token: this.token });
        this.token = "";
        this.$store.commit("LOGOUT");
        this.confirmed = true;
      } catch (err) {
        const detail = err.response && err.response.data && err.response.data.detail;
        this.error = typeof detail === "string" ? detail : "Could not confirm this change. Request a new link from your profile.";
      } finally { this.busy = false; }
    }
  }
};
</script>
